// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"IbvContact_wrapper__1yp90","contact_info":"IbvContact_contact_info__FzUs9"};